import React from "react";

import i18n from "@/i18n";

/**
 * The last line of defence: without it, a render crash is a silent white screen
 * for a guest holding a phone at a table. Reload is the one recovery that always
 * exists, and it costs nothing here — the cart lives in localStorage.
 *
 * A class, because error boundaries still have no hook equivalent. It sits above
 * the providers, so it uses the i18n instance directly rather than the context.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error, info) {
    console.error("Storefront render crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="w-full max-w-md text-center">
          <h1 className="text-lg font-semibold text-gray-900">
            {i18n.t("errors.crash.title")}
          </h1>
          <p className="mt-2 text-sm text-gray-500">{i18n.t("errors.crash.body")}</p>
          <button
            type="button"
            data-testid="crash-reload"
            onClick={() => window.location.reload()}
            className="mt-6 w-full rounded-xl bg-[#E34A27] px-4 py-3 font-medium text-white"
          >
            {i18n.t("errors.crash.reload")}
          </button>
        </div>
      </div>
    );
  }
}
